/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_SectionInputs */



/**
* | output |
* | --- |
* | "In-person conversation" |
*
* @param {Meeting_Offline_SectionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_section = /** @type {((inputs?: Meeting_Offline_SectionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_SectionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Fysiek gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversation en présentiel")
	return /** @type {LocalizedString} */ ("In-person conversation")
});